import React, { useEffect, useState } from 'react';
import { Skeleton } from '@mui/material';

import ArrowIcon from '../../../../assets/icons/ArrowIcon';
import {
  ActionButtonContainer,
  DocumentItem,
  DocumentLink,
  IconWrapper,
  TitleContainer,
  UnreadCount,
  WidgetContainer,
} from './styles';
import { DocumentsWidgetProps } from './types';
import PDFIcon from '../../../../assets/icons/PDFIcon';
import ActionButton from '../../../components/ActionButton/ActionButton';
import { TranslationKeys } from '../../../../i18n/locales/defaultResources';
import { useI18n } from '../../../../hooks/useI18n';
import { handleDocumentPreview } from '../../../../helpers/filePreviewHelper';
import { useDocumentsStore } from '../../../../stores/documentsStore';
import TooltipTranslationHelper from '../../../../helpers/TooltipTranslationHelper';

const DocumentsWidget: React.FC<DocumentsWidgetProps> = ({
  documents,
  onViewAllClick,
  title,
  unreadCount,
}) => {
  const [showSkeleton, setShowSkeleton] = useState(true);
  const { t } = useI18n();
  const { isInitializing } = useDocumentsStore();

  useEffect(() => {
    setShowSkeleton(isInitializing);
  }, [isInitializing]);

  return (
    <WidgetContainer>
      <TitleContainer>
        <h3>{title}</h3>
        {(unreadCount != null || unreadCount != undefined) && (
          <UnreadCount>
            {unreadCount} {t(TranslationKeys.document_widget_unread_indicator)}
          </UnreadCount>
        )}
      </TitleContainer>
      {showSkeleton ? (
        <ul>
          {Array.from({ length: 3 }).map((_, index) => (
            <SkeletonDocument key={index} />
          ))}
        </ul>
      ) : (
        <ul>
          {documents.map((doc, index) => (
            <DocumentItem key={index}>
              <TooltipTranslationHelper
                titleKey={TranslationKeys.documents_list_preview_document}
              >
                <DocumentLink onClick={() => handleDocumentPreview(doc.id)}>
                  <IconWrapper>
                    <PDFIcon color="#323F4B" />
                  </IconWrapper>
                  <span>{doc.name}</span>
                </DocumentLink>
              </TooltipTranslationHelper>
              <a onClick={() => handleDocumentPreview(doc.id)}>
                <ArrowIcon />
              </a>
            </DocumentItem>
          ))}
        </ul>
      )}

      {!showSkeleton && documents.length === 0 && (
        <p>{t(TranslationKeys.documents_list_no_documents_found)}</p>
      )}

      {onViewAllClick && (
        <ActionButtonContainer>
          <ActionButton
            variant="link-button"
            buttonText={t(TranslationKeys.documents_widget_view_all)}
            onClickAction={onViewAllClick}
          />
        </ActionButtonContainer>
      )}
    </WidgetContainer>
  );
};

const SkeletonDocument: React.FC = () => (
  <DocumentItem>
    <Skeleton
      variant="rectangular"
      width={24}
      height={24}
      animation="wave"
      style={{ borderRadius: '8px', marginRight: '8px' }}
    />
    <Skeleton
      width="60%"
      height={24}
      animation="wave"
      style={{ borderRadius: '8px', marginRight: '8px' }}
    />
    <Skeleton
      variant="rectangular"
      width={34}
      height={24}
      animation="wave"
      style={{ borderRadius: '8px' }}
    />
  </DocumentItem>
);

export default DocumentsWidget;
